<script lang="ts">
  export let stats: any;

  import StatsExplanationCompact from "./StatsExplanationCompact.svelte";

  const keys = Object.keys(stats);

</script>

<table>
  <thead>
    <tr>
      <th scope="col">Property</th>
      <th scope="col">Value and Explanation</th>
    </tr>
  </thead>
  <tbody>
    {#each keys as key}
      <tr>
        <td>{key}</td>
        <td>
          <StatsExplanationCompact {key} {stats} value={stats[key]} />
        </td>
      </tr>
    {/each}
  </tbody>
</table>

<style>

table {
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #ddd;
  padding: 4px;
}

tr:nth-child(even){background-color: #f2f2f2;}

th {
  text-align: left;
  background-color: lightgray;
}

</style>